export enum GerealiseerdEnum {
  JA = 'Ja',
  NEE = 'Nee',
}
